import { createContext, useContext, useState, useCallback, ReactNode } from 'react'

// デモの業種タイプ
export type DemoType = 'video' | 'web' | 'office' | 'personal' | null

// グローバルなデモモードフラグ（サービスレイヤーからアクセス可能）
let _isDemoMode = false
export const isDemoModeActive = () => _isDemoMode

interface DemoContextType {
  isDemoMode: boolean
  demoType: DemoType
  enterDemoMode: (type: DemoType) => void
  exitDemoMode: () => void
}

const DemoContext = createContext<DemoContextType | undefined>(undefined)

export function DemoProvider({ children }: { children: ReactNode }) {
  const [isDemoMode, setIsDemoMode] = useState(false)
  const [demoType, setDemoType] = useState<DemoType>(null)

  const enterDemoMode = useCallback((type: DemoType) => {
    _isDemoMode = true  // グローバルフラグを設定
    setIsDemoMode(true)
    setDemoType(type)
  }, [])

  const exitDemoMode = useCallback(() => {
    _isDemoMode = false  // グローバルフラグをクリア
    setIsDemoMode(false)
    setDemoType(null)
  }, [])

  return (
    <DemoContext.Provider value={{ isDemoMode, demoType, enterDemoMode, exitDemoMode }}>
      {children}
    </DemoContext.Provider>
  )
}

export function useDemo() {
  const context = useContext(DemoContext)
  if (context === undefined) {
    throw new Error('useDemo must be used within a DemoProvider')
  }
  return context
}
